const AUTH_URL_ENDPOINTS = {
  shopee: '/auth/api/v1/marketplaces/shopee/auth/url',
  tiktok: '/auth/api/v1/marketplaces/tiktok/auth/url',
}

/**
 * @typedef {Object} MarketplaceIntegrationVm
 * @property {{ post: (url: string) => Promise<{ data?: { data?: { auth_url?: string } } }> }} $http_new
 */

/**
 * Util request autentikasi marketplace dan buka OAuth window.
 * @param {MarketplaceIntegrationVm} vm - Instance Vue yang menyediakan `$http_new`.
 */
export default function useMarketplaceIntegrationRequest(vm) {
  /**
   * @param {string} marketplace
   * @returns {string|undefined}
   */
  const getMarketplaceAuthEndpoint = marketplace => AUTH_URL_ENDPOINTS[marketplace]

  /**
   * Buka popup autentikasi dan dengarkan `INTEGRATION_SUCCESS` dari child window.
   * @param {string} authUrl
   * @returns {boolean} `true` bila popup berhasil dibuka.
   */
  const openAuthWindow = authUrl => {
    if (!authUrl) return false

    const authWindow = window.open(authUrl, '_blank', 'width=1000,height=700,menubar=no,toolbar=no,location=no,status=no')

    if (authWindow) {
      authWindow.focus()

      const handleIntegrationMessage = event => {
        const { type } = event.data
        if (type !== 'INTEGRATION_SUCCESS') return

        window.removeEventListener('message', handleIntegrationMessage)
        authWindow.close()

        window.location.reload()
      }
      window.addEventListener('message', handleIntegrationMessage)
    }

    return Boolean(authWindow)
  }

  /**
   * Ambil `auth_url` dari endpoint marketplace lalu membuka popup autentikasi.
   * @param {'shopee'|'tiktok'|string} marketplace
   * @returns {Promise<{ authUrl: string, response: unknown }>}
   */
  const requestMarketplaceAuthUrl = async marketplace => {
    const endpoint = getMarketplaceAuthEndpoint(marketplace)

    if (!endpoint) {
      throw new Error(`Marketplace "${marketplace}" tidak didukung`)
    }

    const response = await vm.$http_new.post(endpoint)
    const authUrl = response?.data?.data?.auth_url

    if (!authUrl) {
      throw new Error('auth_url tidak ditemukan pada response')
    }

    openAuthWindow(authUrl)

    return {
      authUrl,
      response: response?.data,
    }
  }

  return {
    requestMarketplaceAuthUrl,
    openAuthWindow,
    getMarketplaceAuthEndpoint,
  }
}
